module.exports = __webpack_public_path__ + "static/media/view-all-arrow.c615f70c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/maker/view-all-arrow.svg
 ** module id = 470
 ** module chunks = 0
 **/